<div class="modal-header">
  <h4 class="modal-title">Demandes commerciales</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <p>
    Pour toute demande de mise à jour, démonstration,
    demande de devis ou planification de prestations,
    nous vous invitons à contacter directement votre commercial.
  </p>

  <div class="d-flex justify-content-center">
    <app-dash-block-commercial class="w-300px"></app-dash-block-commercial>
  </div>
</div>
<div class="modal-footer">
  <app-cancel-button (click)="activeModal.dismiss()"></app-cancel-button>
  <button class="btn btn-primary" (click)="activeModal.close()">
    Revenir à la liste des tickets
  </button>
</div>
